import { useStaticQuery, graphql } from 'gatsby';

const useSiteMetadata = () => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          awsApiGatewayUrl
          description
          datadogClientToken
          googleMapsApiKey
          isCypressTest
          siteEnv
          title
        }
      }
    }
  `);
  return {
    ...site.siteMetadata,
    isCypressTest:
      site.siteMetadata.isCypressTest ||
      // @ts-ignore
      (typeof window === 'object' && window.Cypress),
  };
};

export default useSiteMetadata;
